import {
  ComponentClassName,
  SelectComponents,
  ComponentState,
  constants,
} from '../helpers'

const componentMapper: Record<SelectComponents, ComponentClassName> = {
  clearIndicator: 'clear-indicator',
  container: 'container',
  control: 'control',
  dropdownIndicator: 'dropdown-indicator',
  group: 'group',
  groupHeading: 'group-heading',
  indicatorsContainer: 'indicators',
  indicatorSeparator: 'indicator-separator',
  input: 'input',
  inputContainer: 'input-container',
  loadingIndicator: 'loading-indicator',
  loadingMessage: 'loading-message',
  menu: 'menu',
  menuList: 'menu-list',
  menuNotice: 'menu-notice',
  menuPortal: 'menu-portal',
  multiValue: 'multi-value',
  multiValueLabel: 'multi-value__label',
  multiValueRemove: 'multi-value__remove',
  noOptionsMessage: 'menu-notice--no-options',
  option: 'option',
  placeholder: 'placeholder',
  singleValue: 'single-value',
  valueContainer: 'value-container',
}

type state = ComponentState

export const getComponentClass = (
  component: SelectComponents,
  ...options: [state] | [boolean] | [state, boolean] | []
) => {
  const className = `${constants.CLASSNAME_PREFIX}__${componentMapper[component]}`

  const state = typeof options[0] === 'string' ? options[0] : ''
  const shouldTrim = typeof options[0] === 'boolean' ? options[0] : options[1]

  return `${shouldTrim ? '' : '.'}${className}${state ? `--${state}` : ''}`
}
